// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_3pt","cls2":"SearchOnboardingOverhaul-cls2_wuw SearchOnboardingOverhaul-cls1_3pt"};